import type { HeadlineV1Attributes } from '@/features/headline-v1/headline-v1-type';

import React from 'react';

import { Headline, ShimmerBox } from '@/core/features';
import { useDeviceoutput } from '@/core/features/cookies/use-device-output';
import { useHeadlineVariants } from '@/features/headline-v1/use-headline-variants';

export default function HeadlineV1Default({
    htmlSubtitle,
    htmlTitle,
    isLoading,
    subtitleStyle,
    subtitleType,
    titleStyle,
    titleType,
}: HeadlineV1Attributes & { isLoading: boolean }) {
    const { subtitleVariant, titleVariant } = useHeadlineVariants(titleStyle, subtitleStyle, htmlSubtitle);
    const { isDesktopView } = useDeviceoutput();

    if (!titleVariant && !subtitleVariant) {
        return null;
    }

    return (
        <div className={'w-full'}>
            {titleVariant && (
                <Headline
                    htmlTitle={htmlTitle}
                    type={titleType}
                    {...titleVariant}
                    marginBottom={!isDesktopView && !htmlSubtitle ? 8 : titleVariant.marginBottom}
                />
            )}
            {htmlSubtitle &&
                subtitleType &&
                subtitleVariant &&
                (isLoading ? (
                    <ShimmerBox
                        height={'22px'}
                        width={'50%'}
                    />
                ) : (
                    <Headline
                        htmlTitle={htmlSubtitle}
                        type={subtitleType}
                        {...subtitleVariant}
                    />
                ))}
        </div>
    );
}
